import { render, staticRenderFns } from "./ProfitReportTransactionsAdmin.vue?vue&type=template&id=13a8afaa&scoped=true"
import script from "./ProfitReportTransactionsAdmin.vue?vue&type=script&lang=js"
export * from "./ProfitReportTransactionsAdmin.vue?vue&type=script&lang=js"
import style0 from "./ProfitReportTransactionsAdmin.vue?vue&type=style&index=0&id=13a8afaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a8afaa",
  null
  
)

export default component.exports